<span [innerHTML]="svgContent()" class="mp-icon-wrapper"></span>
